// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import Header from '../headerFooter/header';
// import HomeFooter from '../homepage/homefooter';
// import '../blog.css'; // Reuse your existing blog styles or add new ones

// const BlogPost = () => {
//   const { slug } = useParams(); // Get the slug from the URL (e.g., "yoga-benefits")
//   const [post, setPost] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Fetch the specific post by slug from your WordPress folder
//     fetch(`https://satvicpath.com/wordpress/wp-json/wp/v2/posts?slug=${slug}&_embed`)
//       .then(res => res.json())
//       .then(data => {
//         if (data.length > 0) {
//           setPost(data[0]); // WordPress returns an array, we take the first item
//         }
//         setLoading(false);
//       })
//       .catch(err => {
//         console.error(err);
//         setLoading(false);
//       });
//   }, [slug]);

//   if (loading) return <div className="blog-loading">Loading...</div>;
//   if (!post) return <div className="blog-error">Post not found</div>;

//   return (
//     <div>
//       <Header />
      
//       <div className="blog-post-container" style={{maxWidth: '800px', margin: '40px auto', padding: '0 20px', minHeight: '80vh'}}>
//         {/* Featured Image */}
//         {post._embedded && post._embedded['wp:featuredmedia'] && (
//           <img 
//             src={post._embedded['wp:featuredmedia'][0].source_url} 
//             alt={post.title.rendered} 
//             style={{width: '100%', height: 'auto', borderRadius: '12px', marginBottom: '30px'}}
//           />
//         )}

//         {/* Title */}
//         <h1 
//           style={{fontFamily: "'Cormorant Garamond', serif", fontSize: '3rem', color: '#2D3436'}}
//           dangerouslySetInnerHTML={{ __html: post.title.rendered }} 
//         />

//         {/* Meta Info */}
//         <p style={{color: '#888', fontSize: '0.9rem', marginBottom: '30px'}}>
//           Published on {new Date(post.date).toLocaleDateString()}
//         </p>

//         {/* Blog Content */}
//         <div 
//           className="blog-content-body"
//           style={{fontFamily: "'Montserrat', sans-serif", lineHeight: '1.8', fontSize: '1.1rem', color: '#2D3436'}}
//           // This renders the HTML content coming from WordPress
//           dangerouslySetInnerHTML={{ __html: post.content.rendered }} 
//         />
//       </div>

//       <HomeFooter />
//     </div>
//   );
// };

// export default BlogPost;
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async'; 
import { FaWhatsapp, FaTwitter, FaLinkedinIn, FaLink } from 'react-icons/fa';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import './blogpost.css'; 

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [readTime, setReadTime] = useState(0);

  const shareUrl = window.location.href;

  useEffect(() => {
    window.scrollTo(0, 0); 
    
    fetch(`https://satvicpath.com/wordpress/wp-json/wp/v2/posts?slug=${slug}&_embed`)
      .then(res => res.json())
      .then(data => {
        if (data.length > 0) {
          const postData = data[0];
          setPost(postData);

          const rawContent = postData.content.rendered.replace(/<[^>]+>/g, "");
          const wordCount = rawContent.trim().split(/\s+/).length;
          setReadTime(Math.ceil(wordCount / 200));

          fetch(`https://satvicpath.com/wordpress/wp-json/wp/v2/posts?_embed&per_page=3&exclude=${postData.id}`)
            .then(res => res.json())
            .then(relatedData => setRelatedPosts(relatedData));
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [slug]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    alert("Link copied to clipboard!");
  };

  if (loading) return <div className="loading-state">Loading soulful content...</div>;
  if (!post) return <div className="error-state">Post not found</div>;

  const pageTitle = `${post.title.rendered} | SatvicPath`;
  const pageDesc = post.excerpt.rendered.replace(/<[^>]+>/g, "").substring(0, 160);
  const pageImg = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title.rendered,
    "image": [pageImg],
    "datePublished": post.date,
    "dateModified": post.modified,
    "author": [{
        "@type": "Person",
        "name": "Pragya",
        "url": "https://satvicpath.com/about"
      }],
    "publisher": {
      "@type": "Organization",
      "name": "SatvicPath",
      "logo": {
        "@type": "ImageObject",
        "url": "https://satvicpath.com/logo.png"
      }
    },
    "description": pageDesc
  };

  return (
    <HelmetProvider>
      <div className="blog-page-wrapper">
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={pageDesc} />
          <script type="application/ld+json">
            {JSON.stringify(articleSchema)}
          </script>
          <meta property="og:type" content="article" />
          <meta property="og:title" content={pageTitle} />
          <meta property="og:description" content={pageDesc} />
          <meta property="og:image" content={pageImg} />
          <meta property="og:url" content={shareUrl} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image" content={pageImg} />
        </Helmet>

        <Header />
        
        <article className="professional-post-container">
          <nav className="post-breadcrumb">
            <span>SatvicPath</span> — <span>Journal</span>
          </nav>

          <header className="post-header">
            <h1 className="post-main-title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
            <div className="post-meta-strip">
              {/* <span className="meta-item">By Pragya</span>
              <span className="meta-divider">•</span> */}
              <span className="meta-item">{new Date(post.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</span>
              <span className="meta-divider">•</span>
              <span className="meta-item accent-text">{readTime} min read</span>
            </div>
          </header>

          {/* Social Sidebar (RESTORED) */}
          <div className="social-share-sidebar">
            <a href={`https://api.whatsapp.com/send?text=${post.title.rendered}%20${shareUrl}`} target="_blank" rel="noreferrer" className="share-btn wa" title="Share on WhatsApp"><FaWhatsapp /></a>
            <a href={`https://twitter.com/intent/tweet?text=${post.title.rendered}&url=${shareUrl}`} target="_blank" rel="noreferrer" className="share-btn tw" title="Share on Twitter"><FaTwitter /></a>
            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`} target="_blank" rel="noreferrer" className="share-btn li" title="Share on LinkedIn"><FaLinkedinIn /></a>
            <button onClick={copyToClipboard} className="share-btn cl" title="Copy Link"><FaLink /></button>
          </div>

          {pageImg && (
            <div className="featured-image-wrapper">
              <img src={pageImg} alt={post.title.rendered} className="featured-image" />
            </div>
          )}

          <div className="post-content-entry" dangerouslySetInnerHTML={{ __html: post.content.rendered }} />

          <section className="related-section">
            <h3 className="related-heading">Continue Reading</h3>
            <div className="related-grid">
              {relatedPosts.map((rPost) => (
                <Link to={`/post/${rPost.slug}`} key={rPost.id} className="related-card">
                  <div className="related-img-wrapper">
                    <img src={rPost._embedded?.['wp:featuredmedia']?.[0]?.source_url || "https://via.placeholder.com/400x250"} alt={rPost.title.rendered} />
                  </div>
                  <h4 dangerouslySetInnerHTML={{ __html: rPost.title.rendered }} />
                </Link>
              ))}
            </div>
          </section>

          <hr className="post-end-divider" />
          <div className="post-footer"><p>Thank you for walking this path with us.</p></div>
        </article>
        <HomeFooter />
      </div>
    </HelmetProvider>
  );
};

export default BlogPost;